import { render } from "./PrototypesIndex.vue?vue&type=template&id=7cb8417c&scoped=true"
import script from "./PrototypesIndex.vue?vue&type=script&lang=js"
export * from "./PrototypesIndex.vue?vue&type=script&lang=js"

import "./PrototypesIndex.vue?vue&type=style&index=0&id=7cb8417c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb8417c"]])

export default __exports__